module.exports = __webpack_public_path__ + "static/media/6.56b1357e.jpg";